import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

/**
 * Droplet-only fallback for order create when production DO fails.
 * Do not add other shop endpoints here — use digitalAppApi.
 */
export const dropletOrderApi = createApi({
  reducerPath: 'dropletOrderApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://tpomobi.shop' }),
  endpoints: (builder) => ({
    createNewOrderBrowser: builder.mutation({
      query: (body) => ({
        url: '/createOrderAdminBrowser',
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        body,
      }),
    }),
  }),
})
